import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { CalendarPickerModule , KeyValueBlockModule, CustomSourceSelectorModule } from 'ngx-zcs-components';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { IonicModule } from '@ionic/angular';

import { DailyStateOverviewComponent } from './daily-state-overview.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    DailyStateOverviewComponent,
  ],
  imports: [
    BlockTitleComponent,
    CalendarPickerModule,
    CommonModule,
    CustomSourceSelectorModule,
    IonicModule,
    KeyValueBlockModule,
    MatButtonModule,
    MatDatepickerModule,
    MatIconModule,
    MatNativeDateModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts/core') })
  ],
  exports: [
    DailyStateOverviewComponent,
  ],
})
export class DailyStateOverviewModule { }
